const AzureConstant = {
    LOCAL_APP: 'https://localhost:60000/',
    DEV_APP: 'app-draftcombine-dev-001.azurewebsites.net',
    QA_APP: 'app-draftcombine-qa-001.azurewebsites.net',
    CT_APP: 'app-draftcombine-ct-001.azurewebsites.net',
    PROD_APP: 'combine-central.nba.com',
    TENANT_ID: 'e898ff4a-4b69-45ee-a3ae-1cd6f239feb2',
    DEV_CLIENT: '7ea99495-b3a1-42bc-ad21-61851476f131',
    QA_CLIENT: 'f81c6cb7-2089-4de1-9af1-3825b1ca5a3c',
    CT_CLIENT: 'c351dbb8-def2-464b-ba50-8619c6b6da57',
    PROD_CLIENT: '6a202d1e-b177-462f-b11c-577de196a881',
};

export default AzureConstant;